import React from "react";

import { NotificationSnackbar, Skeleton, Stack } from "shared/ui";

import { CategoriesTab } from "features/StopList/components/CategoriesTab";
import { ItemsTab } from "features/StopList/components/ItemsTab";
import { StopListActions } from "features/StopList/components/StopListActions";
import { StopListPicker } from "features/StopList/components/StopListPicker";
import { StopListTabs } from "features/StopList/components/StopListTabs";
import { StopListContext } from "features/StopList/context";
import { useStopListState } from "features/StopList/hooks/useStopListState";

import { Container, Message } from "./styles";

const StopListScreen = () => {
    const state = useStopListState();

    if (state.loading) {
        return (
            <Container>
                <Stack>
                    <Skeleton height="44px" width="320px" />
                    <Skeleton height="44px" width="420px" />
                    <Skeleton height="360px" />
                </Stack>
            </Container>
        );
    }

    if (state.error) {
        return <Message>Не удалось загрузить стоп-лист</Message>;
    }

    return (
        <StopListContext.Provider value={state}>
            <StopListActions />

            <Container>
                <StopListTabs />

                {state.activeTab === "items" ? <ItemsTab /> : <CategoriesTab />}
            </Container>

            <StopListPicker />

            <NotificationSnackbar {...state.notify.snackbarProps} />
        </StopListContext.Provider>
    );
};

export const StopList = StopListScreen;
